import { configValue } from 'utils/config';

type Props = {
  originalWidth: number | undefined;
  originalHeight: number | undefined;
  requestedWidth: number | undefined;
  requestedHeight: number | undefined;
};

export function getFilestackImageAspectRatio({
  originalWidth,
  originalHeight,
  requestedWidth,
  requestedHeight,
}: Props): { width: number; height: number } | undefined {
  // When Filestack mock is enabled we don't have the correct width and height
  if (configValue('filestack', 'mock')) return undefined;

  // When both width and height are provided there's no need to use aspect ratio.
  //
  // In the case where Filestack cuts/clips the image and changes its dimension it
  // would actually be incorrect to provide aspectRatio.
  if (requestedWidth && requestedHeight) return undefined;

  if (!originalWidth || !originalHeight) {
    return undefined;
  }

  return { width: originalWidth, height: originalHeight };
}
